import { render, staticRenderFns } from "./IssueCommentsItem.vue?vue&type=template&id=babfe086&scoped=true"
import script from "./IssueCommentsItem.vue?vue&type=script&lang=js"
export * from "./IssueCommentsItem.vue?vue&type=script&lang=js"
import style0 from "./IssueCommentsItem.vue?vue&type=style&index=0&id=babfe086&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babfe086",
  null
  
)

export default component.exports